class BuildingAnimation {
	/*
        Generates a moving sine wave animation.

        Rather than redrawing the path, this just translates the path along
        the x axis.
    */

	constructor(svg, size, amplitude, speed, color, type = "idling", strokeWidth = 2) {
		this.svg = svg;
		this.type = type;
		this.size = size;
		this.speed = speed;
		this.color = color;
		this.amplitude = amplitude;
		this.strokeWidth = strokeWidth;

		this.frame = 0;
		this.frequency = 0.3;
	}

	drawPolyLine(amplitude, frequency, frame) {
		const { size, speed } = this;
		const points = [];
		const adjustedFrame = frame * speed;

		for (let x = 0; x < size; x += 1) {
			const y = Math.sin(x * frequency + adjustedFrame);
			points.push([x, y * amplitude * 0.5 + amplitude * 0.5].join(" "));
		}

		return points;
	}

	drawPath(amplitude) {
		switch (this.type) {
			case "running": {
				return this.drawPathRunning(amplitude);
			}

			case "error": {
				return this.drawPathError(amplitude);
			}

			case "idling":
			default: {
				return this.drawPathIdle(amplitude);
			}
		}
	}

	drawPathRunning(amplitude) {
		const { size } = this;

		const half = size / 2;
		const quarter = size / 4;
		const adjustedAmplitude = half - amplitude;

		const points = [
			`M ${0} ${half}`,
			`Q ${quarter} ${adjustedAmplitude},`,
			`${half} ${half}`,
			`T ${size} ${half}`,
			`T ${size + half} ${half}`,
			`T ${size + size} ${half}`,
		];

		const drawPath = points.join(" ");

		return drawPath;
	}

	drawPathError(amplitude) {
		const { size } = this;
		const half = size / 2;

		const points = [`M ${0} ${half}`, `h ${size - 2},`, `a 2 ${amplitude} 0 0 1 4 0`, `h ${size * 2},`];

		const drawPath = points.join(" ");

		return drawPath;
	}

	drawPathIdle() {
		const { size } = this;
		const half = size / 2;

		const points = [`M ${0} ${half}`, `h ${size * 4},`];

		const drawPath = points.join(" ");

		return drawPath;
	}

	clearCanvas() {
		while (this.svg.lastChild) {
			this.svg.removeChild(this.svg.lastChild);
		}
	}

	drawSineWave() {
		const svgns = "http://www.w3.org/2000/svg";
		const shape = document.createElementNS(svgns, "path");
		const { frame, amplitude, frequency } = this;

		shape.setAttribute("d", this.drawPath(amplitude, frequency, frame));
		shape.style.strokeWidth = this.strokeWidth;
		shape.style.fill = "none";

		// create a ref
		this.wave = shape;

		// append to svg
		this.svg.appendChild(shape);
	}

	tick() {
		const { wave, frame, size, speed } = this;

		const xPosition = -(frame * speed) % size;
		wave.setAttribute("transform", `translate(${xPosition}, 0)`);

		this.frame += 1;
	}

	finish() {
		this.clearCanvas();
		clearInterval(this.interval);
	}

	start(fps = 60) {
		this.fps = fps;
		this.clearCanvas();
		this.drawSineWave();

		const refreshRate = Math.floor(1000 / this.fps);
		this.interval = setInterval(() => this.tick(), refreshRate);
	}
}

export default BuildingAnimation;
